<template>
    <c-dialog ref="dialog" title="客户账号管理" mode="slide" width="800" enable-flex mask-close :button="false">
        <template #head>
            <div v-if="detailData.customer_code" class="m-detail-tag flex-center-cross">
                <label>{{detailData.customer_name}}</label>
                <c-state :value="detailData.is_new_customer == '1' ? 1 : 2" tag></c-state>
            </div>
        </template>
        <module>
            <module-col>
                    <m-operate>
                        <c-button color="main" v-if="auth('b_customer_sysuser')" prepend-icon="tf-add"
                                  @click="addCustomerUser()">添加账号</c-button>
                    </m-operate>
                    <c-table ref="customUserList" border :paging="false">
<!--                        <c-table-column label="账号" width="100">-->
<!--                            <template #default="{data}">-->
<!--                                <span>{{data.user_name}}</span>-->
<!--                            </template>-->
<!--                        </c-table-column>-->

                        <c-table-column label="姓名" width="100">
                            <template #default="{data}">
                                <span>{{data.user_realname}}</span>
                            </template>
                        </c-table-column>

                        <c-table-column label="电话" width="100">
                            <template #default="{data}">
                                <span>{{data.phone}}</span>
                            </template>
                        </c-table-column>
                        <!--头像-->
                        <c-table-column label="头像" width="100">
                            <template #default="{data}">
                                <c-file v-if="data.head_photo" class="img" :src="data.head_photo" media style="width:30px;height:30px;"></c-file>
                            </template>
                        </c-table-column>

                        <c-table-column label="状态" width="120">
                            <template #default="{data}">
                                <c-switch v-if="auth('b_customer_sysuser') && data.is_manage != 1 " v-model="data.state" :state-value="[1, 2]" :state-text="['启用','禁用']"
                                          @beforeChange="customUserStateHandle(arguments[0], arguments[1], data)"></c-switch>
                                <c-state v-else dict="disableEnableDic" :value="data.state"></c-state>
                            </template>
                        </c-table-column>

                        <c-table-column v-if="auth('b_customer_sysuser')" type="button" label="操作" width="50" button-limit="1">
                            <template #default="{data}">
                                <c-table-button v-if="auth('b_customer_sysuser')" icon="tf-edit" @click="$refs.customerSysuserEdit.open(data)">编辑</c-table-button>
                            </template>
                        </c-table-column>
                    </c-table>
            </module-col>
            <!--编辑用户信息弹窗-->
            <customer-sysuser-edit ref="customerSysuserEdit" @resolve="$refs.customUserList.update()"></customer-sysuser-edit>
        </module>
    </c-dialog>
</template>

<script>
import customerSysuserEdit from "@/pages/system/customer_sysuser_edit.vue";

export default {
    name: 'customerDetail',
    components: {customerSysuserEdit},

    data() {
        return {
            detailData: {}
        }
    },

    methods: {
        open(data) {
            this.id = data.id;
            this.request({
                url: '/customer/detail',
                data: {
                    id: data.id
                },
                loading: true,
                success: data => {
                    this.detailData =  data;
                    //加载客户关联账号列表
                    this.loadCustomUser();
                    //加载客户列表
                    this.$refs.dialog.open();
                }
            });
        },

        /**
         * 添加客户账号
         * @param data
         */
        addCustomerUser() {
            this.$refs.customerSysuserEdit.openForAdd(this.detailData)
        },
        /**
         * 加载客户关联账号
         */
        loadCustomUser() {
            this.$refs.customUserList.load({
                url: '/sys_user/list',
                data:{
                    customer_id: this.id
                }
            });
        },

        /******客户-用户启禁用*********/
        customUserStateHandle(state, next, data) {
            this.request({
                url: '/sys_user/update_state',
                data: {
                    id: data.id,
                    state: state ? 2 : 1
                },
                success: (data, message) => {
                    this.$message({
                        message: message,  // 提示内容,
                        type: 'success'
                    });
                    next();
                }
            })
        },
    }
}
</script>

<style lang="stylus" scoped>

</style>
